var site = site || {};
site.Countdown = (() => {
    const initCountdown = () => { 
        const countdownItems = document.querySelectorAll(".js-countdown-timer");

        if (countdownItems) {
            countdownItems.forEach(countdown => {
                const targetDate = new Date(countdown.dataset.datetime);

                function updateCountdown() {
                    const now = new Date();
                    const diff = targetDate - now;

                    if (diff <= 0) {
                        countdown.querySelector(".js-dayCount").textContent = "000";
                        countdown.querySelector(".js-hourCount").textContent = "00";
                        countdown.querySelector(".js-minCount").textContent = "00";
                        countdown.querySelector(".js-secCount").textContent = "00";
                        return;
                    }

                    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                    const mins = Math.floor((diff / (1000 * 60)) % 60);
                    const secs = Math.floor((diff / 1000) % 60);

                    countdown.querySelector(".js-dayCount").textContent = days;
                    countdown.querySelector(".js-hourCount").textContent = hours.toString().padStart(2, "0");
                    countdown.querySelector(".js-minCount").textContent = mins.toString().padStart(2, "0");
                    countdown.querySelector(".js-secCount").textContent = secs.toString().padStart(2, "0");
                }

                updateCountdown();
                setInterval(updateCountdown, 1000); 
            });
        }
    }

    return {
        initCountdown : initCountdown
    };
})();